import React from 'react'
import {Grid} from '@mui/material'

export default function TOC() {
  return (
    <div className='container-fluid vh-100 p-0'>
      <Grid container spacing={2}>
        <Grid item sm={12} lg={12}>
          <object
            type='application/pdf'
            standby='Loading...'
            data='toc.pdf#toolbar=0&navpanes=0&scrollbar=0'
            style={{height: '100vh', width: '100%'}}
            aria-label='Terms of Service'
          ></object>
        </Grid>
      </Grid>
    </div>
  )
}
